import { toRefs, ref, computed } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import { EVENTS } from '../config/component-lib.esm.js';

//
var script = {
  props: {
    height: {
      type: String,
      default: ''
    },
    overflow: {
      type: String,
      default: ''
    },
    /** The threshold at which this link triggers an Impression event */
    threshold: {
      type: Number,
      default: 1
    },
    paddingBottom: {
      type: Boolean,
      default: true
    }
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      height,
      overflow
    } = toRefs(props);
    const wrapper = ref(null);
    const classes = computed(() => {
      return {
        'link-wrapper--pb': props.paddingBottom
      };
    });
    const {
      stop
    } = useIntersectionObserver(wrapper, _ref2 => {
      let [{
        isIntersecting
      }] = _ref2;
      if (isIntersecting) {
        stop();
        emit('event', EVENTS.IMPRESSION);
        emit('in-view');
      }
    }, {
      rootMargin: '0px',
      threshold: props.threshold
    });
    const styles = computed(() => {
      return {
        height: height.value ? height.value : null,
        overflow: overflow.value ? overflow.value : null
      };
    });
    return {
      classes,
      styles,
      wrapper
    };
  }
};
export { script as default };